import PropTypes from 'prop-types';

/**
 * PropTypes for vehicle detail, containing vehicle detail labels and LCDV16
 */
export default PropTypes.shape({
    date: PropTypes.string,
    model: PropTypes.string,
    bodyStyle: PropTypes.string,
    commercialName: PropTypes.string,
    engine: PropTypes.string,
    transmission: PropTypes.string,
    lcdv16: PropTypes.string
});



// WEBPACK FOOTER //
// ./src/propTypes/vehicleDetail.js